import { Controller } from "@hotwired/stimulus"

// Event regulation modal. Uses a native <dialog> + showModal() so it renders in
// the browser top layer — always above the bottom nav, immune to the stacking
// context that the scroll container (-webkit-overflow-scrolling: touch) creates
// on mobile, which would otherwise trap a plain fixed overlay behind the nav.
export default class extends Controller {
  static targets = ["dialog"]

  // Mount signal: lets a system test wait for the controller to be wired before
  // clicking the rules button, instead of racing the Stimulus mount (#596, #461).
  connect() {
    this.element.dataset.connected = "true"
  }

  open() {
    this.dialogTarget.showModal()
    document.body.style.overflow = "hidden"
  }

  close() {
    this.dialogTarget.close()
  }

  // Click on the dialog element itself (its ::backdrop) closes; clicks on the
  // inner content bubble up with a child target and are ignored.
  backdropClick(event) {
    if (event.target === this.dialogTarget) this.dialogTarget.close()
  }

  // Fires on close() and native Escape — restore background scroll.
  onClose() {
    document.body.style.overflow = ""
  }

  disconnect() {
    document.body.style.overflow = ""
  }
}
